(($, window, document, undefined) => {
  $(() => {

    const showInitialThemesCheckboxes = () => {
      // setTimeout here fixes the issue with back button in browser. When user submits the form and after
      // that returns back setTimeout fixes the issue.
      setTimeout(() => {
        const destination = $('#trip-filter input[name="general_destination"]').filter(':checked').val()
        $('#trip-filter').find(`.themes-checkboxes`).addClass('hidden')
        $('#trip-filter').find(`.themes-checkboxes[data-destination="${destination}"]`).removeClass('hidden')
      }, 0)
    }

    const onThemesCheckboxesToggleVisibility = () => {
      $('#trip-filter input[name="general_destination"]').on({
        change: (e) => {
          const $target = $(e.target)
          const checkboxesWrappers = $('#trip-filter .themes-checkboxes')
          checkboxesWrappers.addClass('hidden')
          checkboxesWrappers.find('input[name="themes[]"]').prop('checked', false);
          checkboxesWrappers
            .filter((i, checkboxesWrapper) => $(checkboxesWrapper).data('destination') === $target.val())
            .removeClass('hidden')
        }
      })
    }

    // const onFilterSubmit = () => {
    //   $('#trip-filter').on('submit', (e) => {
    //     e.preventDefault(); // stop the default /search redirect

    //     const destination = $('#trip-filter input[name="general_destination"]').filter(':checked').val();
    //     const themes = $('#trip-filter input[name="themes[]"]').filter(':checked');
    //     const durations = $('#trip-filter input[name="duration[]"]').filter(':checked');

    //     // Build base URL
    //     let url = `/srp/d-${destination}`;

    //     // Collect multiple values
    //     const themeVals = themes.map(function() {
    //       return $(this).val();
    //     }).get();

    //     const durationVals = durations.map(function() {
    //       return $(this).val();
    //     }).get();

    //     // Build query string if needed
    //     const params = new URLSearchParams();

    //     if (themeVals.length > 0) {
    //       params.append('theme', themeVals.join(','));
    //     }

    //     if (durationVals.length > 0) {
    //       params.append('duration', durationVals.join(','));
    //     }

    //     // Add query params if exist
    //     if ([...params].length > 0) {
    //       url += `?${params.toString()}`;
    //     }

    //     // Redirect
    //     location.assign(url);
    //   });
    // };


    function init() {
      onThemesCheckboxesToggleVisibility()
      showInitialThemesCheckboxes()
      // onFilterSubmit()
    }

    init();

  });
})(window['jQuery'], window, document);



jQuery(document).ready(function($) {

  $('#trip-filter').off('submit').on('submit', function(e) {
    e.preventDefault(); // stop /search redirect

    const destination = $('#trip-filter input[name="general_destination"]').filter(':checked').val();
    const themes = $('#trip-filter input[name="themes[]"]').filter(':checked');
    const durations = $('#trip-filter input[name="duration[]"]').filter(':checked');

    // if no destination, just stop
    if (!destination) {
      console.warn('No destination selected.');
      return;
    }

    // base URL
    let url = `/srp/d-${destination}`;

    // gather multiple values
    const themeVals = themes.map(function() { return $(this).val(); }).get();
    const durationVals = durations.map(function() { return $(this).val(); }).get();

    // build query string
    const params = new URLSearchParams();

    if (themeVals.length > 0) params.append('theme', themeVals.join(','));
    if (durationVals.length > 0) params.append('duration', durationVals.join(','));

    if ([...params].length > 0) url += `?${params.toString()}`;

    // redirect
    window.location.href = url;
  });

});
